import { render, staticRenderFns } from "./AquacultureTile.vue?vue&type=template&id=6c2d7dbc&scoped=true"
import script from "./AquacultureTile.vue?vue&type=script&lang=js"
export * from "./AquacultureTile.vue?vue&type=script&lang=js"
import style0 from "./AquacultureTile.vue?vue&type=style&index=0&id=6c2d7dbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2d7dbc",
  null
  
)

export default component.exports